// export const server = "http://192.168.157.68:5005/api/v1";
export const server = "https://server.medsarthi.com/api/v1";

export const defaultBlogCoverImage =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-FQ5DJHlnsoTrpZc5LARYlxPTcCUt7Mpvkw&s";
